import { createFileRoute } from "@tanstack/react-router";
import { MediaPage } from "../../components/media";
import { MediaType } from "../../generated/graphql";

export const Route = createFileRoute("/media/videos")({
  component: VideosPage,
});

function VideosPage() {
  return <MediaPage mediaType={MediaType.Video} basePath="/media/videos" />;
}
